import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider, createBrowserRouter } from "react-router";
import "./index.css";
import { HelmetProvider } from "react-helmet-async";

// lazy imports (je Route eigener Chunk)
const RootLayout = lazy(() => import("./routes/RootLayout"));
const Home = lazy(() => import("./routes/Home"));
const Leistungen = lazy(() => import("./routes/Leistungen"));
const Impressum = lazy(() => import("./routes/Impressum"));
const Datenschutz = lazy(() => import("./routes/Datenschutz"));

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <Suspense fallback={null}>
        <RootLayout />
      </Suspense>
    ),
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={null}>
            <Home />
          </Suspense>
        ),
      },
      {
        path: "leistungen",
        element: (
          <Suspense fallback={null}>
            <Leistungen />
          </Suspense>
        ),
      },
      {
        path: "impressum",
        element: (
          <Suspense fallback={null}>
            <Impressum />
          </Suspense>
        ),
      },
      {
        path: "datenschutz",
        element: (
          <Suspense fallback={null}>
            <Datenschutz />
          </Suspense>
        ),
      },
    ],
  },
]);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <HelmetProvider>
      <Suspense fallback={null}>
        <RouterProvider router={router} />
      </Suspense>
    </HelmetProvider>
  </React.StrictMode>
);
